<template>
    <main>
        <div class="container d-flex justify-content-center align-items-center min-vh-100">
            <div class="row border rounded-5 p-3 bg-white shadow box-area" id="row">
                <div class="col-md-6 rounded-4 d-flex justify-content-center align-items-center flex-column left-box"
                    id="bg-container" style="background: #2F437A;">
                    <div class="featured-image mb-3">
                        <h1 style="color: #FEC93C; text-align: center; font-size: 5vw;">TECH FOR FILIPINO YOUTH</h1>
                    </div>
                </div>
                <div class="col-md-6 right-box">
                    <div class="row align-items-center">
                        <div class="header-text mb-4" style="text-align: center;">
                            <h2>Welcome back, Admin!</h2>
                        </div>
                        <label for="selectEventCategory" class="form-label">E-mail Address:</label>
                        <div class="mb-3">
                            <input type="text" class="form-control form-control-lg bg-light fs-6"
                                placeholder="Email address" v-model="loginForm.email" @input="v$.email.$touch">
                            <div v-if="v$.email.$errors[0]" class="alert alert-danger m-0 p-1">
                                <em> {{ v$.email.$errors[0].$message }}</em>
                            </div>
                        </div>

                        <label for="selectEventCategory" class="form-label">Password:</label>
                        <div class="mb-1">
                            <input type="password" class="form-control form-control-lg bg-light fs-6" placeholder="Password"
                                v-model="loginForm.password" @input="v$.password.$touch">
                            <div v-if="v$.password.$errors[0]" class="alert alert-danger m-0 p-1">
                                <em> {{ v$.password.$errors[0].$message }}</em>
                            </div>
                        </div>

                        <div class="input-group mb-5 d-flex justify-content-between">

                        </div>
                        <div class="input-group mb-3">
                            <button @click="login" id="login-btn" class="btn btn-lg btn-primary w-100 fs-6">Log In</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { reactive } from 'vue'
import { useStore } from 'vuex'
import useVuelidate from '@vuelidate/core'
import { required, minLength, email, maxLength } from '@vuelidate/validators'

export default {
    setup() {

        // Login form data
        const loginForm = reactive({
            email: '',
            password: ''
        });

        // Vuelidate rules
        const rules = reactive({
            email: {
                required,
                email,
                maxLength: maxLength(254)
            },
            password: {
                required,
                minLength: minLength(6)
            }
        });

        const v$ = useVuelidate(rules, loginForm);

        const store = useStore();

        const login = async () => {

            const result = await v$.value.$validate();

            if (result) {
                v$.value.$reset();

                // Log in user
                store.dispatch('auth/login', loginForm);
            } else {
                alert('Please fill up the form correctly');
            }

        }

        return {
            loginForm: loginForm,
            login,
            v$
        }
    }
}
</script>
<style scoped src="@/assets/css/admin-login.css"></style>